"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));
var _mobx = require("mobx");
var _utils = require("@seedlang/utils");
var _state = require("@seedlang/state");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var MILLISECONDS_BEFORE_CHECK_LOAD = 2500;
var VideoPlayerWrapper = function VideoPlayerWrapper(Component) {
  var _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2(props) {
      var _this;
      _classCallCheck(this, _class2);
      _this = _callSuper(this, _class2, [props]);
      _initializerDefineProperty(_this, "loading", _descriptor, _this);
      _initializerDefineProperty(_this, "initialPlayFinished", _descriptor2, _this);
      _initializerDefineProperty(_this, "errorLoading", _descriptor3, _this);
      _initializerDefineProperty(_this, "playing", _descriptor4, _this);
      _initializerDefineProperty(_this, "isNative", _descriptor5, _this);
      _initializerDefineProperty(_this, "videoLoaded", _descriptor6, _this);
      _initializerDefineProperty(_this, "playAfterError", _descriptor7, _this);
      _initializerDefineProperty(_this, "canPlay", _descriptor8, _this);
      _initializerDefineProperty(_this, "unmounted", _descriptor9, _this);
      _initializerDefineProperty(_this, "initialTimestamp", _descriptor10, _this);
      _initializerDefineProperty(_this, "readyTimestamp", _descriptor11, _this);
      _initializerDefineProperty(_this, "readyForDisplay", _descriptor12, _this);
      if (props.autoPlay) {
        _this.play();
      }
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        if (!prevProps.autoPlay && this.props.autoPlay && !this.playing || this.props.autoPlay && this.props.autoPlayTimestamp !== prevProps.autoPlayTimestamp) {
          this.play();
        } else if (prevProps.videoClip && this.props.videoClip && prevProps.videoClip.mp4Url !== this.props.videoClip.mp4Url) {
          this.loading = true;
          this.logEvent('component-did-update');
          if (this.isNative && !this.props.delayLoad) {
            this.loadVideo();
          } else if (this.isNative && this.props.delayLoad) {
            this.logEvent('delay-load-video');
            setTimeout(this.loadVideo, 400);
          }
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.unloadVideo();
        this.video = null;
      }
    }, {
      key: "hasVideoClip",
      get: function get() {
        return (0, _utils.isPresent)(this.props.videoClip);
      }
    }, {
      key: "hideIcon",
      get: function get() {
        return this.props.hideIcon || !this.hasVideoClip && !this.props.objectUrl;
      }
    }, {
      key: "showSpinnerIcon",
      get: function get() {
        return !this.props.usingDataSaverHeader && this.loading;
      }
    }, {
      key: "showRefreshIcon",
      get: function get() {
        return !this.hideIcon && !this.showSpinnerIcon && this.status === 'ended';
      }
    }, {
      key: "showPlayIcon",
      get: function get() {
        return !this.hideIcon && !this.showSpinnerIcon && !this.showRefreshIcon && this.status !== 'playing' && this.status !== 'ended';
      }
    }, {
      key: "src",
      get: function get() {
        if (this.props.useWebm && this.props.videoClip) {
          return this.props.videoClip.webmUrl;
        }
        if (this.props.videoClip) {
          return this.props.videoClip.mp4Url;
        }
        return this.props.objectUrl;
      }
    }, {
      key: "status",
      get: function get() {
        if (this.loading) {
          return 'loading';
        }
        if (this.playing) {
          return 'playing';
        }
        if (this.initialPlayFinished) {
          return 'ended';
        }
        return 'paused';
      }
    }, {
      key: "setUpNativePlayer",
      value: function () {
        var _setUpNativePlayer = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(video) {
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                // mobile only
                this.isNative = true;
                if (video && !this.video) {
                  this.video = video;
                  //clearTimeout(this.timeout);
                  this.initializeCheckIfLoaded();
                  this.logEvent('set-up-native-player');
                  if (this.props.delayLoad) {
                    setTimeout(this.loadVideo, 200);
                    this.logEvent('delay-load-video');
                  } else {
                    this.loadVideo();
                  }
                }
              case 2:
              case "end":
                return _context.stop();
            }
          }, _callee, this);
        }));
        function setUpNativePlayer(_x) {
          return _setUpNativePlayer.apply(this, arguments);
        }
        return setUpNativePlayer;
      }()
    }, {
      key: "onReadyForDisplay",
      value: function onReadyForDisplay() {
        // mobile only
        this.readyTimestamp = new Date().getTime();
        this.readyForDisplay = true;
        var loadTime = this.readyTimestamp - this.initialTimestamp;
        this.logEvent('on-ready-for-display', "loadTime: ".concat(loadTime));
      }
    }, {
      key: "showErrorIfNotLoaded",
      value: function showErrorIfNotLoaded() {
        this.logEvent('check-show-error-if-not-loaded');
        if (!this.readyForDisplay) {
          this.logEvent('video-not-loaded-show-error');
          this.initialTimestamp = null;
          this.reloadVideoAfterError();
          // this.errorLoading = true;
        }
      }
    }, {
      key: "onCanPlay",
      value: function onCanPlay() {
        this.logEvent('on-can-play');
        this.canPlay = true;
        if ((this.props.autoPlay || this.playAfterError) && (!this.initialPlayFinished && !this.playing || this.props.forcePlay)) {
          this.play();
        } else {
          this.loading = false;
        }
      }
    }, {
      key: "onEndPlayback",
      value: function onEndPlayback() {
        // web only or mobile inline
        if (this.props.loop) {
          return;
        }
        if (this.props.afterVideoPlayback) {
          this.props.afterVideoPlayback(this.props.card, this.props.cardState);
        }
        if (!this.initialPlayFinished && this.props.afterInitialPlay) {
          this.props.afterInitialPlay(this.props.card, this.props.cardState);
        }
        this.initialPlayFinished = true;
        this.pause();
      }
    }, {
      key: "unloadVideo",
      value: function () {
        var _unloadVideo = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                this.logEvent('unload-video');
                if (!this.video) {
                  _context2.next = 10;
                  break;
                }
                _context2.prev = 2;
                _context2.next = 5;
                return this.video.unloadAsync();
              case 5:
                _context2.next = 10;
                break;
              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](2);
                this.logEvent('unload-video-error');
              case 10:
              case "end":
                return _context2.stop();
            }
          }, _callee2, this, [[2, 7]]);
        }));
        function unloadVideo() {
          return _unloadVideo.apply(this, arguments);
        }
        return unloadVideo;
      }()
    }, {
      key: "logEvent",
      value: function logEvent(event, value) {
        // console.log('log event', event, value, this.props.videoClip.id, this.props.cardState)
      }
    }, {
      key: "loadVideo",
      value: function () {
        var _loadVideo = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
          var videoClip;
          return _regeneratorRuntime().wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                this.logEvent('load-video');
                this.readyForDisplay = false;
                this.loading = true;
                this.canPlay = false;
                this.initialPlayFinished = false;
                // this.unloadVideo();
                videoClip = this.props.videoClip.localAsset ? this.props.videoClip.mp4Url : {
                  uri: this.props.videoClip.mp4Url
                };
                _context3.next = 8;
                return this.video.loadAsync(videoClip, {}, false);
              case 8:
                this.timeout = setTimeout(this.checkLoadStatus, MILLISECONDS_BEFORE_CHECK_LOAD);
              case 9:
              case "end":
                return _context3.stop();
            }
          }, _callee3, this);
        }));
        function loadVideo() {
          return _loadVideo.apply(this, arguments);
        }
        return loadVideo;
      }()
    }, {
      key: "reloadVideoAfterError",
      value: function reloadVideoAfterError() {
        var _this2 = this;
        this.logEvent('reload-video-after-error');
        this.readyForDisplay = false;
        this.video = null;
        this.unmounted = true;
        setTimeout(function () {
          return _this2.unmounted = false;
        }, 200);
        this.initializeCheckIfLoaded();
        this.errorLoading = false;
        this.playAfterError = true;
      }
    }, {
      key: "initializeCheckIfLoaded",
      value: function initializeCheckIfLoaded() {
        var _this3 = this;
        this.logEvent('initialize-check-if-loaded');
        this.initialTimestamp = new Date().getTime();
        if (_state.AppUI.siteIsDefault) {
          setTimeout(function () {
            return _this3.showErrorIfNotLoaded();
          }, 4000);
        }
      }
    }, {
      key: "onPlaybackStatusUpdate",
      value: function onPlaybackStatusUpdate(status) {
        // mobile only
        if (!this.videoLoaded) {
          this.logEvent('on-playback-status-update');
        }
        if (!status.error && status.isLoaded !== false) {
          if (!this.videoLoaded) {
            this.logEvent('on-playback-status-update-loaded');
          }
          clearTimeout(this.timeout);
          this.videoLoaded = true;
          this.errorLoading = false;
          if (!this.props.loop && status.didJustFinish) {
            if (this.props.afterVideoPlayback) {
              this.props.afterVideoPlayback(this.props.card, this.props.cardState);
            }
            if (!this.initialPlayFinished && this.props.afterInitialPlay) {
              this.props.afterInitialPlay(this.props.card, this.props.cardState);
            }
            this.initialPlayFinished = true;
            this.pause();
          }
        }
      }
    }, {
      key: "checkLoadStatus",
      value: function checkLoadStatus() {
        this.logEvent('check-load-status');
        this.loading = false;
        if (!this.videoLoaded) {
          this.logEvent('check-load-status-error');
          this.errorLoading = true;
        }
      }
    }, {
      key: "onError",
      value: function onError() {
        if (this.playing) {
          this.pause();
        }
      }
    }, {
      key: "pause",
      value: function () {
        var _pause = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
          return _regeneratorRuntime().wrap(function _callee4$(_context4) {
            while (1) switch (_context4.prev = _context4.next) {
              case 0:
                this.playing = false;
                if (!this.video) {
                  _context4.next = 4;
                  break;
                }
                _context4.next = 4;
                return this.video.pauseAsync();
              case 4:
              case "end":
                return _context4.stop();
            }
          }, _callee4, this);
        }));
        function pause() {
          return _pause.apply(this, arguments);
        }
        return pause;
      }()
    }, {
      key: "play",
      value: function () {
        var _play = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
          return _regeneratorRuntime().wrap(function _callee5$(_context5) {
            while (1) switch (_context5.prev = _context5.next) {
              case 0:
                if (!(this.errorLoading || !this.canPlay)) {
                  _context5.next = 2;
                  break;
                }
                return _context5.abrupt("return");
              case 2:
                _context5.prev = 2;
                if (!this.video) {
                  _context5.next = 11;
                  break;
                }
                if (this.playing) {
                  _context5.next = 7;
                  break;
                }
                _context5.next = 7;
                return this.video.setPositionAsync(0);
              case 7:
                _context5.next = 9;
                return this.video.setIsLoopingAsync(this.props.loop);
              case 9:
                _context5.next = 11;
                return this.video.playAsync();
              case 11:
                this.loading = false;
                this.playing = true;
                _context5.next = 18;
                break;
              case 15:
                _context5.prev = 15;
                _context5.t0 = _context5["catch"](2);
                this.logEvent('play-error', _context5.t0.message || 'Unknown error playing video');
              case 18:
              case "end":
                return _context5.stop();
            }
          }, _callee5, this, [[2, 15]]);
        }));
        function play() {
          return _play.apply(this, arguments);
        }
        return play;
      }()
    }, {
      key: "onTogglePlay",
      value: function onTogglePlay() {
        if (this.playing) {
          this.pause();
        } else {
          this.play();
        }
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          hasVideoClip: this.hasVideoClip,
          hideIcon: this.hideIcon,
          showSpinnerIcon: this.showSpinnerIcon,
          showRefreshIcon: this.showRefreshIcon,
          showPlayIcon: this.showPlayIcon,
          src: this.src,
          status: this.status,
          onCanPlay: this.onCanPlay,
          onEndPlayback: this.onEndPlayback,
          onError: this.onError,
          errorLoading: this.errorLoading,
          onTogglePlay: this.onTogglePlay,
          playing: this.playing,
          setUpNativePlayer: this.setUpNativePlayer,
          onPlaybackStatusUpdate: this.onPlaybackStatusUpdate,
          play: this.play,
          playNative: this.playNative,
          reloadVideoAfterError: this.reloadVideoAfterError,
          isNative: this.isNative,
          loading: this.loading,
          unmounted: this.unmounted,
          onReadyForDisplay: this.onReadyForDisplay
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "loading", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return true;
    }
  }), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "initialPlayFinished", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "errorLoading", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "playing", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "isNative", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "videoLoaded", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "playAfterError", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "canPlay", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "unmounted", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, "initialTimestamp", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor11 = _applyDecoratedDescriptor(_class2.prototype, "readyTimestamp", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor12 = _applyDecoratedDescriptor(_class2.prototype, "readyForDisplay", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class2.prototype, "hasVideoClip", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "hasVideoClip"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "hideIcon", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "hideIcon"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showSpinnerIcon", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showSpinnerIcon"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showRefreshIcon", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showRefreshIcon"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showPlayIcon", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showPlayIcon"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "src", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "src"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "status", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "status"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "setUpNativePlayer", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "setUpNativePlayer"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onReadyForDisplay", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onReadyForDisplay"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showErrorIfNotLoaded", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "showErrorIfNotLoaded"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onCanPlay", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onCanPlay"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onEndPlayback", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onEndPlayback"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "unloadVideo", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "unloadVideo"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "logEvent", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "logEvent"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "loadVideo", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "loadVideo"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "reloadVideoAfterError", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "reloadVideoAfterError"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "initializeCheckIfLoaded", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "initializeCheckIfLoaded"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onPlaybackStatusUpdate", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onPlaybackStatusUpdate"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "checkLoadStatus", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "checkLoadStatus"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onError", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onError"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "pause", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "pause"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "play", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "play"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onTogglePlay", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onTogglePlay"), _class2.prototype), _class2)) || _class;
};
VideoPlayerWrapper.displayName = 'VideoPlayerWrapper';
var _default = exports["default"] = VideoPlayerWrapper;